import React from "react";
import { formatCollection } from "common/utils/strings";
import { FlexRow } from "../../../../Common/__styles__/Layout";
import { Tag } from "../../../../Common/Tag";
import { useBuilderWatch } from "./form/form";
import { generateLabelsForRoles } from "./RoleAndGroupSelector";
import { useSubmissionsBuilderContext } from "./SubmissionsBuilderContext";
import {
  submissionHiddenFromPublicByDefaultToViewerType,
  viewerTypeLabel,
} from "./viewerType";

export function HeaderMiddleContainer() {
  const { canCreateRoles, canCreateGroups } = useSubmissionsBuilderContext();

  const hiddenFromPublicByDefault = useBuilderWatch(
    "hiddenFromPublicByDefault",
  );

  const viewerType = submissionHiddenFromPublicByDefaultToViewerType(
    hiddenFromPublicByDefault,
  );

  const creatorLabels = generateLabelsForRoles(canCreateRoles);
  const groupLabels = canCreateGroups.map(userGroup => userGroup.name);

  const label = formatCollection([...creatorLabels, ...groupLabels]) ?? null;

  return (
    <FlexRow gap="s">
      {label ?
        <Tag
          styleVariant="neutral"
          leftIconName="clipboard-pen"
          data-testid="creator-type-tag"
        >
          {label}
        </Tag>
      : null}
      {viewerType ?
        <Tag
          styleVariant="neutral"
          leftIconName="eye"
          data-testid="viewer-type-tag"
        >
          {viewerTypeLabel[viewerType]}
        </Tag>
      : null}
    </FlexRow>
  );
}
